// @flow

import { getApiBaseUrl, basicGet } from '../utils/api'
import type { APIError } from '../types'
import type { Action } from '../types/actions/profile'
import { getErrorAction } from '../utils/actions'

export const GET_USER_SUCCESS = 'GET_USER_SUCCESS'
export const GET_USER_FAILURE = 'GET_USER_FAILURE'
export const GET_USER_REQUEST = 'GET_USER_REQUEST'
//export const GET_USER_COMPILED_QUESTS_SUCCESS = 'GET_USER_COMPILED_QUESTS_SUCCESS'
//export const GET_USER_COMPILED_QUESTS_FAILURE = 'GET_USER_COMPILED_QUESTS_FAILURE'
//export const GET_USER_COMPILED_QUESTS_REQUEST = 'GET_USER_COMPILED_QUESTS_REQUEST'

export function getUserSuccess(response: Object): Action {
  return {
    type: GET_USER_SUCCESS,
    user: response.user
  }
}

export function getUserFailure(error: APIError): Action {
  return getErrorAction(GET_USER_FAILURE, error)
}

export function getUserRequest(): Action {
  return {
    type: GET_USER_REQUEST
  }
}

/*
export function getUserCompiledQuestsSuccess (response: Array<Object>) : Action {
  return {
    type: GET_USER_COMPILED_QUESTS_SUCCESS,
    quests: response
  }
}

export function getUserCompiledQuestsFailure (error: APIError) : Action {
  return getErrorAction(
    GET_USER_COMPILED_QUESTS_FAILURE,
    error
  )
}

export function getUserCompiledQuestsRequest () : Action {
  return {
    type: GET_USER_COMPILED_QUESTS_REQUEST
  }
}
*/

export function getUser(userId: number): Function {
  return (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrl()}/api/organizations/${
      state.organization.orgId
    }/users/${userId}`
    return basicGet(
      state,
      dispatch,
      url,
      getUserRequest,
      getUserSuccess,
      getUserFailure
    )
  }
}

/*
export function getUserCompiledQuests (userId: number) : Function {
  return (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrl()}/api/organizations/${state.organization.orgId}/users/${userId}/compiled_quests`
    return (basicGet(state, dispatch, url, getUserCompiledQuestsRequest, getUserCompiledQuestsSuccess, getUserCompiledQuestsFailure))
  }
}
*/
